import { CdkDragDrop } from '@angular/cdk/drag-drop';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { faArrowRightArrowLeft } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-drag-and-drop-list',
  templateUrl: './drag-and-drop-list.component.html',
  styleUrls: ['./drag-and-drop-list.component.scss'],
})
export class DragAndDropListComponent {
  @Input() leftTitle!: string;

  @Input() rightTitle!: string;

  @Input() leftSubtitle?: string;

  @Input() rightSubtitle?: string;

  @Input() leftList!: any[];

  @Input() rightList!: any[];

  @Input() leftSideEmptyLabel!: string;

  @Input() rightSideEmptyLabel!: string;

  @Input() moreActionsTemplate?: TemplateRef<any>;

  @Output() removed = new EventEmitter<CdkDragDrop<any>>();

  @Output() added = new EventEmitter<CdkDragDrop<any>>();

  faArrowRightArrowLeft = faArrowRightArrowLeft;

  get itemsAmount() {
    return this.rightList.length + this.leftList.length;
  }

  @Input() extractLeftDescription = (item: any) => item;

  @Input() extractRightDescription = (item: any) => item;

  onRemoved(event: CdkDragDrop<any>): void {
    if (this.isSameContainer(event)) {
      return;
    }

    this.removed.emit(event);
  }

  onAdded(event: CdkDragDrop<any>): void {
    if (this.isSameContainer(event)) {
      return;
    }

    this.added.emit(event);
  }

  private isSameContainer(event: CdkDragDrop<any>): boolean {
    return event.previousContainer === event.container;
  }
}
